module.exports = __webpack_public_path__ + "static/media/tl-awaiting-approval.6921f06b.svg";